import {request} from '../helpers/request'
import React from 'react';
import LoadingComponent from './common/LoadingComponent'
import PagerComponent from './common/PagerComponent'
import LimitComponent from './common/LimitComponent'
import ListingComponent from './common/ListingComponent'
import SearchboxComponent from './common/SearchboxComponent'
import $ from 'jquery'
import Immutable from 'immutable'
import ModalComponent from './common/ModalComponent'
import _ from 'lodash'
import {browserHistory} from 'react-router'
import {t} from '../helpers/translate'
import {redirectIfNotLoggedIn, isAgent, checkOrg, isViewonly} from '../helpers/access'
import {isRimiOrg, isCanuckProduct, isNonMedicalProduct, isInternationalStudentProduct, isVisitorToCanadaProduct} from '../helpers/rimi'
import {getStatus} from '../helpers/getStatusText'
import {Well} from 'react-bootstrap'
import { ExportToCsv } from 'export-to-csv';
import { Button } from 'react-bootstrap'
let config = require('config');

class Search extends React.Component {
  constructor(props) {
    redirectIfNotLoggedIn();
    super(props);
    this.state = {
      sources: (this.props.location.query.sources || 'all').split(','),
      insurer: this.props.location.query.insurer || 'all',
      allsources: [],
      org: sessionStorage.getItem('org'),
      page: this.props.location.query.page || 1,
      limit: this.props.location.query.limit || 10,
      orderby: this.props.location.query.orderby || 'sale_date',
      order: this.props.location.query.order || 'asc',
      criteria: this.getCriteriaFromQuery(this.props.location.query),
      csv: null,
      searchSource: null,
      displaycsv: 'no',
      searchData: null,
      showModal: false,
      modalTitle: null,
      modalBody: null,
      messageType: 'info',
      loading: false,
      loadingText: 'Processing',
      total: 0
    }
  }

  getCriteriaKeys() {
    return config.default.search[this.props.route.searchType][sessionStorage.getItem('org')].map((field) => field.key)
  }

  componentWillMount() {
    if (!sessionStorage.getItem('auth')) {
      browserHistory.push('/')
    }
    if ((this.props.params.source != 'universal') && _.isEmpty(config.default.clients[this.props.params.source])) {
      this.errorMessage('Form Configuration not found.');
      window.history.back();
    }
    this.loadData();
    this.performSearch(this.props.location.query);
  }

  getCriteriaFromQuery(query) {
    let criteriaKeys = this.getCriteriaKeys();
    let criteria = Immutable.Map({});

    for (let key of criteriaKeys) {
      if (query[key]) {
        criteria = criteria.set(key, query[key]);
      }
    }

    return criteria.toObject();
  }

  componentWillReceiveProps(newProps) {
    this.performSearch(newProps.location.query);
  }

  getCriteria() {
    return this.state.criteria
  }

  setSearchCriteria(query) {
    this.state.criteria = this.getCriteriaFromQuery(query);
    this.state.limit = query.limit || '10';
    this.state.page = query.page || '1';
    this.state.orderby = query.orderby || (this.props.route.searchType == 'report' ? 'created_at' : 'sale_date');
    this.state.order = query.order || 'asc';
    this.state.displaycsv = query.csv || 'no';
  }

  getPage() {
    return this.state.page
  }

  getLimit() {
    return this.state.limit
  }

  getOrderBy() {
    return this.state.orderby
  }

  getOrder() {
    return this.state.order
  }

  getRequestBody() {
    if (this.props.route.searchType == 'applicant' && _.isEmpty(this.state.criteria.sources)) {
       this.state.criteria.sources = 'all';
    }

    let requestBody = {
      criteria: this.state.criteria,
      page: this.getPage(),
      limit: this.getLimit(),
      orderby: this.getOrderBy(),
      order: this.getOrder(),
    };

    if (this.props.route.searchType !== 'claim'){
      requestBody.criteria.org = sessionStorage.getItem('org');
    }

    return requestBody
  }

  loadSearchData(responseData, statusCode) {
    this.setState({ loading: true });
    if (statusCode == 200) {
      this.setState({
          searchData: this.handleResponse(responseData, 200),
          displaycsv: this.props.route.searchType == 'report' ? 'no' : 'yes'
        })
    } else {
      this.setState({ loading: false });
      this.showModal(t('Error'), responseData.messages.map((item, i) => <div key={i}>{item.message}</div>));
    }
  }

  loadCsvSearchData(responseData, statusCode) {
    if (statusCode == 200) {
      let elements;
      switch (this.props.route.searchType) {
        case 'applicant':
          elements = responseData.applicants;
          break;
        case 'user':
          elements = responseData.members;
          break;
        default:
          elements = responseData.applicants;
      }
      this.setState({csv: this.cleanCsv(elements)});
      const data = this.state.csv;
      const currentDate = new Date();
      const headers = this.getCsvHeader();

      const options = {
        filename: `Dashboard Search Result ${this.formatDate(currentDate)}`,
        decimalSeparator: '.',
        showLabels: true,
        headers: headers
      };

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(data);
    }
  }

  formatDate(date) {
    return (date.getDate() < 10? "0" : "") + date.getDate() + "-" 
            + ((date.getMonth()+1) < 10? "0" : "") + (date.getMonth()+1) + "-"
            + date.getFullYear();
  }

  getCsvHeader() {
    let headers = [];
    let trackingCode = checkOrg('ingle') ? 'Referrer' : 'Agent';
    switch(this.props.route.searchType) {
      case 'applicant':
      case 'quote':
        headers = [
          'Policy Number',
          'First Name',
          'Last Name',
          'Gender',
          'Student ID',
          'Date of Birth',
          'Country of Origin',
          'Effective Date',
          'Expiry Date',
          'Email',
          'Street',
          'City',
          'Province',
          'Country Code',
          'Product',
          'School Name',
          'Status',
          'Date Issued',
          'Last Modified',
          isRimiOrg(this.state.org) ? 'Payment Schedule' : 'empty',
          'Premium',
          (isRimiOrg(this.state.org) && !isViewonly()) ? 'Paid Premium' : 'empty',
          isRimiOrg(this.state.org) ? 'Policy Limit' : 'empty',
          !isViewonly() ? trackingCode : 'empty'
        ];
        headers = this.cleanArray(headers);
        return headers;
      case 'user':
        headers = [
          'Name',
          'Email',
          'Active',
          'Agent Code',
          'Company',
          'User Type',
          'Schools'
        ];
        if (!checkOrg('ingle')) {
          headers.pop();
        }
        return headers;
    }
  }

  cleanCsv(elements) {
    const elementsRes = [];
    const searchType = this.props.route.searchType;

    if (searchType == 'applicant' || searchType == 'quote') {
      elements.forEach((element) => {
        let row = [
          this.cleanCsvElement(element.policy_number),
          this.cleanCsvElement(element.first_name),
          this.cleanCsvElement(element.last_name),
          this.cleanCsvElement(element.sex),
          this.cleanCsvElement(element.student_number),
          this.cleanCsvElement(element.dob),
          this.cleanCsvElement(element.application.additional_data['country_of_origin']),
          this.cleanCsvElement(element.application.effective_date),
          this.cleanCsvElement(element.application.expiry_date),
          this.cleanCsvElement(element.email),
          this.cleanCsvElement(`${this.cleanCsvElement(element.address_line_1)} ${this.cleanCsvElement(element.address_line_2)}`),
          this.cleanCsvElement(element.city),
          this.cleanCsvElement(element.state),
          this.cleanCsvElement(element.country_code),
          this.cleanCsvElement(`${element.application.source_full_name} ${element.application.source_category}`),
          this.cleanCsvElement(element.school_name),
          this.cleanCsvElement(
            getStatus(
              element.application.effective_date,
              element.application.expiry_date,
              element.application.active,
              element.application.status
            )),
          this.cleanCsvElement(element.application.sale_date),
          this.cleanCsvElement(element.updated_at),
          isRimiOrg(this.state.org) ? this.getPaymentOption(this.cleanCsvElement(element.application.additional_data['payment_option'])) : 'empty',
          this.cleanCsvElement(element.premium),
          (isRimiOrg(this.state.org) && !isViewonly()) ? this.cleanCsvElement(element.additional_data['paid_premium']) : 'empty',
          isRimiOrg(this.state.org) ? this.cleanCsvElement(this.getPolicyLimit(element)) : 'empty',
          !isViewonly() ? this.cleanCsvElement(element.application.additional_data['tracking_code']) : 'empty'
        ];
        row = this.cleanArray(row);
        elementsRes.push(row);
      })
    } else if (searchType == 'user') {
      elements.forEach((element) => {
        let row = [
          this.cleanCsvElement(`${element.first_name} ${element.last_name}`),
          this.cleanCsvElement(element.email),
          this.cleanCsvElement(element.status),
          this.cleanCsvElement(element.data.csr_token),
          this.cleanCsvElement(element.data.company),
          this.cleanCsvElement(element.access_level),
          this.getSchools(element)
        ];
        if (!checkOrg('ingle')) {
          row.pop();
        }
        elementsRes.push(row);
      })
    }

    return elementsRes;
  }

  cleanArray(elements) {
    let i = 0;
    while(i < elements.length) {
      if (elements[i] == 'empty') {
        elements.splice(i, 1);
        continue;
      }
      i++;
    }
    return elements;
  }

  getPolicyLimit(element) {
    if (isCanuckProduct(element.application.source)) {
      return 7000000;
    }
    if (isNonMedicalProduct(element.application.source)) {
      return Math.ceil(element.application.additional_data['trip_cost'] /100) * 100;
    }
    if (isInternationalStudentProduct(element.application.source)) {
      return 2000000;
    }
    if (isVisitorToCanadaProduct(element.application.source)) {
      return element.application.additional_data['coverage'];
    }
  }

  cleanCsvElement(element) {
    return (element === null || element === undefined) ? '' : element;
  }

  preserveCsvNumber(number) {
    return '="' + number + '"';
  }

  getSchools(element) {
    if (element.data.all_schools) {
      return this.cleanCsvElement(element.data.all_schools).join();
    }
    if (element.data.school) {
      return this.cleanCsvElement(element.data.school);
    }
    return '';
  }

  getPaymentOption(paymentOption) {
    switch(paymentOption) {
      case 'monthly':
        return 'Monthly Payment';
      case 'lumpsum':
      default:
        return 'Lump Sum';
    }
  }

  handleModalClose() {
    this.setState({
      showModal: false
    });
  }

  showModal(title, body, messageType = 'info') {
    this.setState({
      showModal: true,
      modalBody: body,
      modalTitle: title,
      messageType: messageType
    });
  }

  showLoading(text = t('Processing')) {
    this.setState({
      loading: true,
      loadingText: text,
    });
  }

  errorMessage(msg){
     return this.showModal(t('Error'), t(msg), 'error');
  }

  noticeMessage(msg){
     return this.showModal(t('Notice'), t(msg), 'notice');
  }

  performSearch(query) {
    if (_.isEmpty(query)){
      return
    }

    const errorMessage = t('Please enter information in at least one search field.');

    this.setSearchCriteria(query)

    if (this.props.route.searchType == 'applicant') {
      const sources = this.state.criteria.sources;
      const org = this.state.criteria.org;
      const insurer = this.state.criteria.insurer;
      const status = this.state.criteria.status;

      this.state.searchSources = this.state.criteria.sources;

      delete this.state.criteria.org;
      delete this.state.criteria.insurer;

      if (sources == undefined) {
        return
      }

      if (sources == 'all') {
        delete this.state.criteria.sources;

        if (_.isEmpty(this.state.criteria)) {
          return this.errorMessage(errorMessage);
        }

        if (this.state.criteria.status == 'all') {
          delete this.state.criteria.status;

          if (_.isEmpty(this.state.criteria)) {
            return this.errorMessage(errorMessage);
          }
          this.state.criteria.status = status;
        }
      }

      this.state.criteria.sources = sources;
      this.state.criteria.org = org;
      this.state.criteria.insurer = insurer;
    }

    if (!query.orderby){
      this.setState({orderby: 'sale_date', order: 'asc'});
    }
    this.setState({ loading: true });

    $.when(request(
      this.getSearchUrl(), 
      'POST', 
      this.getRequestBody(), 
      this.loadSearchData.bind(this)
      )).done(this.hideLoadingModal.bind(this));
  }

  handleResendResponse(responseData, statusCode) {
    this.setState({processing: false});
    if (statusCode == 200) {
        this.showModal(t('Success'), responseData.message, false);
    } else {
      const errorMessage = responseData.messages ? responseData.messages[0] : 'Your report has failed to send';
      this.showModal(t('Error'), errorMessage, false);
    }
    this.hideLoadingModal();
  }

  resendReport(scope, report_id) {
    scope.showLoading(t('Resending Report'));
    $.when(request(
      `${config.default.api}/report/${report_id}`, 
      'POST', 
      null, 
      scope.handleResendResponse.bind(scope))
    ).done(scope.hideLoadingModal.bind(scope));
  }

  performCsvSearch() {
    this.state.criteria.sources = this.state.searchSources;
    var csvRequestBody = this.getRequestBody();
    csvRequestBody.limit = 25000;
    csvRequestBody.page = 1;
    this.showLoading("Processing Please wait...");

    $.when(request(
      this.getSearchUrl(), 
      'POST',
      csvRequestBody,
      this.loadCsvSearchData.bind(this)
    )).done(this.hideLoadingModal.bind(this));
  }

  setInsurer(val){
    this.setState({insurer: val})
    this.setSources(val)
  }

  loadData() {
    this.showLoading(t('Searching'));
    $.when(request(
      `${config.default.api}/sources/`, 
      'GET', 
      null, 
      this.loadSources.bind(this))
    ).done(this.hideLoadingModal.bind(this));
  }

  setSources(insurer){
    let tempSources = [{value: 'all', text: 'All'}];

    this.state.allsources.forEach(function(source) {
      const oneSource = {
        value: source.name,
        text: `${source.full_name} ${source.category}`
      }

      if ((config.default.clients[source.name] !== undefined) && source.active) {
        if ((insurer == 'all') || (insurer == source.insurer)) {
          tempSources.push(oneSource);
        }
      }
    });

    this.setState({
      sources: tempSources
    });
  }

  loadSources(responseData, statusCode) {
    if (statusCode == 200) {
      let temp_sources = [{value: 'all', text: 'All Products'}];

      if (!isAgent('ingle')) {
        responseData.sources.forEach(function(source) {
          if ((config.default.clients[source.name] !== undefined) && source.active){
            temp_sources.push({
              value: source.name,
              text: `${source.full_name} ${source.category}`
            });
          }
        }); 
      }

      this.setState({
        allsources: responseData.sources
      });

      this.setSources(this.state.insurer);
    }
  }

  hideLoadingModal (){
    this.setState({ loading: false })
  }

  getListingConfig(searchType){
    switch(this.props.route.searchType){
      case "applicant":
        return config.default.applicant[sessionStorage.getItem('org')];
      case "quote":
        return config.default.quote[sessionStorage.getItem('org')];
      case "report":
        return config.default.report[sessionStorage.getItem('org')];
      case "user":
        return config.default.user[sessionStorage.getItem('org')];
      case "claim":
        return config.default.claim;
    }
  }

  getDataArray(searchType, responseData){
    switch(this.props.route.searchType){
      case "applicant":
      case "quote":
      case "claim":
        return responseData.applicants
      case "user":
        return responseData.members
      case "report":
        return responseData.reports
    }
  }

  handleResponse(responseData, statusCode) {
    this.setState({total: responseData.total});

    if (statusCode == 200) {
      if (responseData.total == 0) {
        this.noticeMessage('Your search produced no results.');
        return <Well className="text-center">
          <h4>
            {t('Your search produced no results.')}
          </h4>
        </Well>
      } else {
        const className = (this.props.route.searchType == 'user') ? 'col-lg-8' : 'col-lg-10';

        return <div id="results" name="results" className={className}>
          <div className="row">
            <div className="col-sm-9">
              <div className="form-control-static"><b>{t('Number of Results:')} {responseData.total}</b></div>
            </div>
            <div className="col-sm-3"><LimitComponent currentLimit={this.getLimit()}
            /></div>
          </div>
          <div className="row">
            <div className="col-sm-12 div-center">
              <PagerComponent page={this.getPage()} limit={this.getLimit()} total={responseData.total}/>
            </div>
            <div className="clearfix"></div>
            <br />
            <ListingComponent
              config={this.getListingConfig(this.props.route.searchType)}
              dataArray={this.getDataArray(this.props.route.searchType, responseData)}
              source={this.props.params.source}
              endpoint='applicant'
              searchType={this.props.route.searchType}
              page={this.getPage()} limit={this.getLimit()}
              orderby={this.getOrderBy()} order={this.getOrder()}
              resendReport={this.resendReport}
              scope={this}
            />
            <div className="col-sm-12 div-center">
              <PagerComponent page={this.getPage()} limit={this.getLimit()} total={responseData.total} />
            </div>
          </div>
        </div>
      }
    } else if (statusCode == 400) {
      this.showModal(t('Error'), t('System error occurred! Please try again or contact admin.'));
      return <Well className="text-center">
        {
          responseData.messages.map((item, i) => <div key={i}>{item.message}</div>)
        }
      </Well>
    }
  }

  scrollToTheResults() {
    $('html, body').animate({scrollTop: 760}, 'fast');
  }

  getSearchUrl(){
    switch(this.props.route.searchType){
      case "applicant":
      case "quote":
        var org = this.props.params.source
        break;
      case "report":
      case "user":
        var org = sessionStorage.getItem('org')
        break;
      case "claim":
        var org = sessionStorage.getItem('org')
        break;
    }

    const url_base = config.default.search_params[this.props.route.searchType].url_base;
    const url_suffix = config.default.search_params[this.props.route.searchType].url_suffix;

    return `${config.default[url_base]}${url_suffix}${org}`;
  }

  getPageTitle(){
    return `${t('Search')} ${t(config.default.search_params[this.props.route.searchType].search_title)}`
  }

  showAgentDisclaimer(){
    return isAgent('ingle') ?
      <h4 className="disclaimer">
        {`${t('Search and manage is available for MSH products only. For assistance please')}`} <a href="/contact_us">contact us</a>.
      </h4>
      : null;
  }

  showCSVDownload() {
    if (this.state.displaycsv === 'yes') {
      return (this.state.total < 25001) ? <Button onClick={() => this.performCsvSearch()}>{t('Download All Results')}</Button> : <div><Button disabled onClick={() => this.performCsvSearch()}>{t('Download All Results')}</Button><div className='red'>Maximum results to export is 25,000. Please refine search by applying additional search parameters </div></div>
    }
  }

  render() {
    return (<div className="container col-lg-12">
      <div className="text-center bg-inherit">
        <h2 className="page-title">{this.getPageTitle()}</h2>
        {this.showAgentDisclaimer()}
        <LoadingComponent show={this.state.loading} text={this.state.loadingText}/>
      </div>
      <ModalComponent
        title={this.state.modalTitle}
        body={this.state.modalBody}
        onClose={this.handleModalClose.bind(this)}
        show={this.state.showModal}
        messageType={this.state.messageType}
      />
      <h4 className="text-center page-subtitle">{t('Fill in as many of the following criteria as you can to generate a search.')}</h4>
      <div className="row row-flex">
        <div className="search-box col-md-4">
          <SearchboxComponent {...this.state} searchType={this.props.route.searchType} searchFunction={this.performSearch.bind(this)} setInsurer={this.setInsurer.bind(this)}/>
          <br />
        </div>
      </div>
      {this.state.searchData}
      <br/>
      <div className="col-sm-12 div-center bottom-pager">
        {this.showCSVDownload()}
      </div>
    </div>
    );
  }
}

Search.defaultProps = {};

export default Search;


// WEBPACK FOOTER //
// ./src/components/Search.js